import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { CalenderComponent } from './calender/calender.component';
import { ReactiveFormsModule } from '@angular/forms';
import { NgbPaginationModule, NgbAlertModule} from '@ng-bootstrap/ng-bootstrap';
import {CarouselModule} from 'ngx-owl-carousel-o';

@NgModule({
  declarations: [CalenderComponent],
  imports: [
    CommonModule,
    ReactiveFormsModule,
    NgbPaginationModule, CarouselModule
  ]
})
export class CalenderModule { }


